import React, { useMemo } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { buildSchoolQueryPersistOptions } from './persistOptions';
import { queryClient } from './queryClient';

type AppQueryProviderProps = {
  children: React.ReactNode;
};

/**
 * React Query + localStorage persist 골격.
 * Phase 2+에서 `school` prefix query만 dehydrate한다.
 */
export function AppQueryProvider({ children }: AppQueryProviderProps) {
  const persistOptions = useMemo(() => buildSchoolQueryPersistOptions(), []);

  if (!persistOptions) {
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
  }

  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      {children}
    </PersistQueryClientProvider>
  );
}
